module.exports = __webpack_public_path__ + "img/close_notification.33db0b3e.svg";